import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    callout:
      'This information corresponds to what you provided when you first registered with Shine. If you wish to change any information, please ',
    contactUs: 'contact us',
  },
  fr: {
    callout:
      'Ces informations correspondent à celles renseignées lors de votre première inscription chez Shine. Si vous souhaitez modifier des informations, ',
    contactUs: 'contactez-nous',
  },
} as const);
